import axiosInstance from '../Api/axiosInstance';

// Base URL of your backend (make sure this matches your backend's deployment URL)
const API_URL = process.env.REACT_APP_API_URL + '/api/payment';

// Fetch Stripe publishable key from the backend
export const fetchStripeConfig = () => axiosInstance.get('/payment/config');

// Create a payment intent on the backend
export const createPaymentIntent = (
	amount,
	customerEmail,
	customerName,
	templateId,
	companyId,
) =>
	axiosInstance.post('/payment/create-payment-intent', {
		amount,
		customerEmail,
		customerName,
		templateId,
		companyId,
	});

// Fetch all purchases for a specific company
export const getPurchasesByCompany = (companyId) =>
	axiosInstance.get(`/payment/purchases/${companyId}`);

// Fetch Stripe price details by price ID
export const getStripePrice = (priceId) =>
	axiosInstance.get(`/payment/price/${priceId}`);

// Fetch multiple Stripe prices by price IDs
export const getStripePrices = (priceIds) =>
	axiosInstance.post('/payment/prices', { priceIds });
